import React, { 
    useState,
    useEffect,
    useContext,
    } from 'react';
  import { Field, Form } from 'react-final-form';
  import { Col } from 'react-bootstrap';
  import {
    Card, CardBody, CardTitleWrap,
  } from '@/shared/components/Card';
   import Select from 'react-select';
  import {
      FormButtonToolbar,
      FormContainer,
      FormGroup,
      FormGroupField,
      FormGroupLabel,
      FormHalfContainer,
    } from '@/shared/components/form/FormElements';
    import { renderMaskedField } from '@/shared/components/form/FormField';
    import PasswordField from '@/shared/components/form/Password';
    // import Select from 'react-select';
    import { Button } from '@/shared/components/Button';
    import PropTypes from 'prop-types';
    import { AuthContext } from '../../../../../context/AuthContext';

  
    const AddUser = ({ onSubmit }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [country, setCountry] = useState([]);
    const { apiGlobal } = useContext(AuthContext);

    const fetchCountryList = async () => {
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } 
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

   
    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <CardTitleWrap>
              <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
            </CardTitleWrap>
            <Form onSubmit={onSubmit}>
              {({ handleSubmit, form }) => (
                <FormContainer onSubmit={handleSubmit}>
                  <FormHalfContainer>
                    <FormGroup>
                      <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="name"
                          component="input"
                          type="text"
                          placeholder="Enter Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>User Name(Email)<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="username"
                          component="input"
                          type="email"
                          placeholder="Enter UserName/Email"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Mobile No 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="countryCode"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                    // isLoading={isLoading}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    // borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                  <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                              </div>
                            )}
                          />

                          {/* Phone Input */}
                          <Field
                            name="mobile1"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                    // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  // borderRadius: '5px',
                                  // border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                  <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                              </div>
                            )}
                          />
                        </div>
                        {/* <Field
                          name="mobile1"
                          component={renderMaskedField}
                          type="text"
                          mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                          placeholder="Enter Mobile 1"
                          required
                          style={{ height: '45px' }}
                          
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                  </FormHalfContainer>
                  <FormHalfContainer>
                    <FormGroup>
                      <FormGroupLabel>Designation<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="designation"
                          component="input"
                          type="text"
                          placeholder="Enter Degisnation"
                          required
                          style={{ height: '45px' }}
                          
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Password<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="password"
                          component={PasswordField}
                          placeholder="Enter Password"
                          required
                          style={{ height: '45px' }}
                          
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Whatsapp no<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="mobile2"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={12}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="Enter Whatsapp no"
                          required
                          style={{ height: '45px' }}
                          
                        />
                      </FormGroupField>
                    </FormGroup>
                  </FormHalfContainer>
                  <FormButtonToolbar>
                    <Button variant="primary" type="submit">Submit</Button>
                  </FormButtonToolbar>
                </FormContainer>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>
      
    );
  };

  AddUser.propTypes = {
      onSubmit: PropTypes.func.isRequired,
    };

  export default AddUser;

